import React, {createContext, useReducer, useMemo} from "react";

let RecibidosContext = createContext();

let initialState = {
  openRespuestaComercial: false,
  documentos: []
};

let reducer = (state, action) => {
  switch (action.type) {
    case "reset": {
        return initialState;
    }
    case "toggleRespuestaComercial": {
        return { ...state, openRespuestaComercial: !state.openRespuestaComercial };
    }
    case "setDocumentosRespuesta": {
        return { ...state, documentos: action.data};
    }
    default:
      return state;
  }
};

function RecibidosProvider(props) {
  let [state, dispatch] = useReducer(reducer, initialState);
  let value = useMemo(() => ({ state, dispatch }), [state]);

  return (
    <RecibidosContext.Provider value={value}>{props.children}</RecibidosContext.Provider>
  );
}

let RecibidosConsumer = RecibidosContext.Consumer;

export { RecibidosContext, RecibidosProvider, RecibidosConsumer };